import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbDateParserFormatter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

import { AggregateComponent } from './aggregate';
import { BreadcrumbComponent } from './breadcrumb';
import { AutoFocusOnLoadDirective, BtnProcessingDirective } from './directives';
import { FooterComponent } from './footer';
import { DatepickerConfig, MomentDateFormatter } from './ng-bootstrap';
import { PaginatorComponent } from './paginator';
import {
  AssetStatePipe, DatetimePipe, LocalePipe, OtaVersionFromFilePipe, RoleNamePipe, TempNamePipe, TempUnitPipe,
  TimezonePipe,
} from './pipes';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { EnumValue } from './pipes/enum-value.pipe';
import { SearchComponent } from './search';
import { WeekPickerComponent } from './week-picker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AssetStatePipe,
    DatetimePipe,
    LocalePipe,
    OtaVersionFromFilePipe,
    RoleNamePipe,
    TempNamePipe,
    TempUnitPipe,
    TimezonePipe,
    AutoFocusOnLoadDirective,
    BtnProcessingDirective,
    CapitalizePipe,
    EnumValue,
  ],
  declarations: [
    AggregateComponent,
    AggregateComponent,
    BreadcrumbComponent,
    FooterComponent,
    PaginatorComponent,
    SearchComponent,
    WeekPickerComponent,
  ],
  providers: [
    LocalePipe,
    RoleNamePipe,
    TempNamePipe,
    TempUnitPipe,
    TimezonePipe,
    { provide: NgbDatepickerConfig, useClass: DatepickerConfig },
    { provide: NgbDateParserFormatter, useClass: MomentDateFormatter },
  ],
  exports: [
    AggregateComponent,
    BreadcrumbComponent,
    CommonModule,
    FooterComponent,
    FormsModule,
    PaginatorComponent,
    AutoFocusOnLoadDirective,
    BtnProcessingDirective,
    AssetStatePipe,
    DatetimePipe,
    LocalePipe,
    RoleNamePipe,
    SearchComponent,
    TempNamePipe,
    TempUnitPipe,
    TimezonePipe,
    OtaVersionFromFilePipe,
    WeekPickerComponent,
    CapitalizePipe,
    EnumValue,
  ],
})
export class SharedModule {}
